import React, { useLayoutEffect, useState } from 'react';

function ResponsiveWrapper({ children, childRef, maxWidth, maxHeight, excludeHeight, containerStyle }) {
  const [layout, setLayout] = useState({
    childWidth: 0,
    childHeight: 0,
    scale: 1
  });

  useLayoutEffect(() => {
    const child = childRef?.current;
    if (!child) return undefined;

    const measureAndScale = () => {
      const childWidth = child.clientWidth;
      const childHeight = child.clientHeight;
      if (!childWidth || !childHeight) return;

      const availableWidth = maxWidth ?? window.innerWidth;
      const availableHeight = maxHeight ?? window.innerHeight;
      const widthScale = availableWidth > 0 ? availableWidth / childWidth : 1;
      const heightScale = availableHeight > 0 ? availableHeight / childHeight : 1;
      const scale = Math.min(1, excludeHeight ? widthScale : Math.min(widthScale, heightScale));

      setLayout(previous =>
        previous.childWidth === childWidth && previous.childHeight === childHeight && previous.scale === scale
          ? previous
          : { childWidth, childHeight, scale }
      );
    };

    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(measureAndScale) : null;
    if (resizeObserver) resizeObserver.observe(child);
    window.addEventListener('resize', measureAndScale);
    measureAndScale();

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', measureAndScale);
    };
  }, [childRef, maxWidth, maxHeight, excludeHeight]);

  const { childWidth, childHeight, scale } = layout;
  const isMeasured = childWidth > 0 && childHeight > 0;
  const scaledHeight = isMeasured ? childHeight * scale : 0;

  return (
    <div
      style={{
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        height: `${scaledHeight}px`,
        ...containerStyle
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: isMeasured ? `${childWidth}px` : undefined,
          height: isMeasured ? `${childHeight}px` : undefined,
          visibility: isMeasured ? 'visible' : 'hidden',
          transform: `scale(${scale})`,
          transformOrigin: 'top left'
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default ResponsiveWrapper;
